// The *Unassigned voices* tab of the identities page (ADR-0077): the voice twin of the
// Unassigned faces tab — the shared selection shell around the pure list, each voice with its
// clip. A viewer reads and listens; the actions and the checkboxes wait for a collaborator.
import { FaceActionNotice } from '@/components/faces/FaceActionNotice'
import { UnassignedVoicesList } from '@/components/identities/voices/UnassignedVoicesList'
import { VoiceClipPlayback } from '@/features/voices/VoiceClipPlayer'
import type { UnassignedVoice } from '@/services/api/identity-voices'
import { UnassignedSelectionShell } from '../UnassignedSelectionShell'
import { useUnassignedVoices } from './useUnassignedVoices'

const COPY = 'identity.unassignedVoices'

const player = (voice: UnassignedVoice) =>
  voice.audio_url ? <VoiceClipPlayback url={voice.audio_url} /> : null

export function UnassignedVoicesTab({ caseId }: { caseId: string }) {
  const voices = useUnassignedVoices(caseId)
  const readOnly = !voices.isLoading && !voices.canDecide && voices.voices.length > 0
  return (
    <UnassignedSelectionShell
      caseId={caseId}
      copy={COPY}
      selection={voices}
      canDecide={voices.canDecide}
    >
      {readOnly ? (
        <FaceActionNotice copy={COPY} errorKey={null} readOnly readOnlyKey={`${COPY}.readOnly`} />
      ) : null}
      <UnassignedVoicesList
        caseId={caseId}
        voices={voices.voices}
        isLoading={voices.isLoading}
        selection={
          voices.canDecide ? { isSelected: voices.isSelected, onToggle: voices.toggle } : undefined
        }
        player={player}
      />
    </UnassignedSelectionShell>
  )
}
